import React, { useState } from "react";
import BuscarPaciente from "./components/BuscarPaciente";
import axiosInstance from "../config/axiosConfig";

const PagosPaciente = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [paciente, setPaciente] = useState(null);
  const [pagos, setPagos] = useState([]);

  const pagosPaciente = async () => {
    try {
      // Llamada a la API para obtener los movimientos por periodo
      const response = await axiosInstance.post("/financiero/cartola/paciente", { 'id_paciente': paciente.id,
                                                                                  'fecha_inicio': startDate,
                                                                                  'fecha_fin': endDate});
      const movimientosFiltrados = response.data.data;
      setPagos(movimientosFiltrados);

    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    }
  };

  const handleSeleccionPaciente = (paciente) => {
    setPaciente(paciente)
  }

  return (
    <div className="container mt-4">
      <div className="card p-3">
        <h4 className="mb-3">Buscar Paciente</h4>
          <div className="row mb-3">
            <BuscarPaciente onSelect={handleSeleccionPaciente} movimientos={true} />
              <div className="col-md-6">
                <label>Fecha de inicio</label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <label>Fecha de fin</label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
            </div>
          </div>

          <button className="col-3 btn btn-primary mb-3" onClick={() => pagosPaciente()}>
            Filtrar Pagos
          </button>
      </div>

      {pagos && (
        <div className="card mt-4 p-3">
          <h5>Pagos</h5>
          <table className="table table-striped mt-3">
            <thead>
              <tr>
                <th>ID Pago</th>
                <th>Detalle</th>
                <th>Fecha de Pago</th>
                <th>Observacion</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>
              {pagos.map(pago => (
                <tr key={pago.id_movimiento}>
                  <td>{pago.id_movimiento}</td>
                  <td>{pago.detalle}</td>
                  <td>{pago.fecha}</td>
                  <td>{pago.observacion}</td>
                  <td>${parseInt(pago.monto).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PagosPaciente;
